import { DividerTemplate } from "@fluentui/web-components";
import { styles as DividerStyles } from "./divider.styles.js";
import { DesignSystem } from "../design-system.js";
import { Divider } from "./divider.js";
/**
 * The Fabric Divider component.
 *
 * @public
 */
export const definition = Divider.compose({
    name: `${DesignSystem.prefix}-divider`,
    template: DividerTemplate,
    styles: DividerStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=divider.definition.js.map